import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";


export default function TrackersEditModel(props) {
    //console.debug("RTS Break TrackersEditModel");

    const [model, setModel] = useState(props.model);
    const [repoModels] = useState([ {value:'AT1', label:"AT1"}
                                    ,{value:'AT2.5', label:"AT2.5"}
                                    ,{value:'AT3', label:"AT3"}
                                    ,{value:'AT3-F', label:"AT3-F"}
                                ]);


    function valChange(e, val){
        setModel(val.value);
        props.setModelFx(val.value);
        props.setFormDirtyFx(1);
    }

 
    return(
        <>
            <Autocomplete
                options={repoModels}
                renderInput={(params) => <TextField {...params} label="Model" margin='normal' required size="small" />}
                value={repoModels.find(v => v.value===model)}
                onChange={valChange}
                getOptionLabel={(repoModel) => repoModel.label}
                renderOption={(props, repoModel) => (
                    <Box component="li" {...props} key={repoModel.value}>
                        {repoModel.label}
                    </Box>
                )}
            />
        </>
    );
}
